import {styled} from "styled-components";
import {Card, Divider} from "antd";

export const StyledDivider = styled(Divider)`
margin: 0 !important;
    
  
`;
export const StyledCard = styled(Card)`
    border: none;
    .ant-card-body{
        padding: 0 !important;
    }
`;